import type { ReactNode } from 'react';

export interface CardProps {
  title: ReactNode;
  /** 見出し右側の操作や凡例。 */
  actions?: ReactNode;
  children: ReactNode;
}

/** 明色ページ上の白いカード。見出しは必ず出し、actionsがあるときだけ右側へ足す。 */
export function Card({ title, actions, children }: CardProps) {
  return (
    <section className="card">
      <div className="card-head">
        <h2 className="card-title">{title}</h2>
        {actions === undefined ? null : <div className="card-actions">{actions}</div>}
      </div>
      <div className="card-body">{children}</div>
    </section>
  );
}
